<template>
	<v-card>
		<div>Wizard not found for this device.</div>
	</v-card>
</template>

<script>
export default {};
</script>
